import { NewVersionNotice } from "@/components/shared/NewVersionNotice";
import { AI_OUTPUT_DISCLAIMER } from "@/policies/disclaimer";

/**
 * Legal's standing notice about AI output, drawn by the shell so no pane rewrite
 * can lose it. No controls: it cannot be dismissed. It spans the working area,
 * not the rail, which shows no AI output.
 */
export function V2DisclaimerFooter() {
  return (
    <footer
      data-testid="v2-disclaimer-footer"
      className="border-t border-border bg-background px-4 py-2 text-center text-[11.5px] text-muted-foreground"
    >
      <p>{AI_OUTPUT_DISCLAIMER}</p>
    </footer>
  );
}

/**
 * The shell's last row, from the rail's edge to the window's: the new-version notice when a
 * newer build is served, then Legal's notice. Outside the scrolling column, so a long draft
 * cannot push either off the bottom, and in a row of its own, so neither covers a page's
 * controls: the column above is shorter by what the row holds.
 */
export function ShellFoot() {
  return (
    <div
      data-testid="v2-shell-foot"
      className="col-start-2 col-end-[-1] row-start-3"
    >
      <NewVersionNotice />
      <V2DisclaimerFooter />
    </div>
  );
}
